import { Box, HStack, Header, Pressable, Text } from '@rbilabs/universal-components';

import { getDesignToken, primitive } from 'styles/constants';
export const Container = Box.withConfig({
  alignItems: 'center',
  justifyContent: 'center',
  padding: '2',
  height: '16',
  backgroundColor: getDesignToken('color-contrast-background'),
  shadow: '2',
  _web: {
    cursor: 'pointer',
  },
});

export const NotificationWrapper = HStack.withConfig({
  alignItems: 'center',
  maxWidth: getDesignToken('layout-section-max-width'),
  color: primitive.$mayoEggWhite,
  width: 'full',
});

export const IconContainer = Box.withConfig({
  marginLeft: '2',
});

export const DetailsContainer = Pressable.withConfig({
  flex: '1',
  marginLeft: '4',
});

export const Heading = Header.withConfig({
  variant: 'headerTwo',
  color: primitive.$mayoEggWhite,
  marginBottom: '0',
});

export const Details = Text.withConfig({
  color: primitive.$mayoEggWhite,
  fontSize: 'xs',
});

export const Close = Pressable.withConfig({
  marginRight: '$2',
});

export const ActionContainer = Box.withConfig({});
